// extracted by mini-css-extract-plugin
export var active = "styles-module--active--5fea2";
export var customBox = "styles-module--customBox--5a475";
export var filterItem = "styles-module--filterItem--eb66e";
export var input = "styles-module--input--41e08";
export var text = "styles-module--text--f65ee";